const handlePromocodeInUrl = location => {
  if (location.search.includes("?p=")) {
    const url = new URLSearchParams(location.search);
    return url.get("p");
  }
  return false;
};

export default handlePromocodeInUrl;
